import { qs, qsa } from '../utils'
import bidello from '../bidello'
import gsap, { Power4 } from 'gsap'
import menu from '../menu'
import scroll from '../animations/scroll/locomotiveScroll'

export const singleTimeTransition = {
  name: 'time-single',

  to: {
    namespace: 'time-single',
  },

  once({ next }) {
    const tl = animation(next.container)

    bidello.on('loaderEnd', () => {
      tl.play()
    })
  },

  enter({ next, current }) {
    current.container.style.display = 'none'

    const tl = animation(next.container)

    return tl.play()
  },

  leave({ next, current }) {
    if (menu.isOpen) {
      menu.menuLeave()
    }

    gsap.set(next.container, { autoAlpha: 0 })

    return gsap.to(current.container, {
      opacity: 0,
      duration: 1.2,
      onComplete: () => {
        scroll.scrollTo({ target: 0, options: { duration: 0, disableLerp: true } })
      }
    })
  }
}

const animation = (container) => {
  const time = qsa('[data-over-hero]', container)
  const title = qs('h1', container)
  const image = qs('img', container)
  const lines = qsa('.line', container)
  const toggle = qs('.c-view-map', container)

  const tl = gsap.timeline({ paused: true })
  // tl.timeScale(1.2)

  tl
    .set(container, { autoAlpha: 1 })
    .from(image, {
      duration: 2,
      scale: 1.3,
      autoAlpha: 0,
      ease: Power4.easeOut
    })
    .add('other')
    .from(title, {
      duration: 1.6,
      yPercent: 100,
      ease: Power4.easeOut
    }, 'other-=1.4')
    .from(lines, {
      duration: 1.2,
      scaleX: 0,
      ease: Power4.easeOut
    }, 'other-=0.8')
    .from(time, {
      duration: 1.6,
      yPercent: 100,
      stagger: 0.1,
      ease: Power4.easeOut
    }, 'other')
    .from(toggle, {
      duration: 1.6,
      autoAlpha: 0,
      ease: Power4.easeOut
    }, 'other')

  return tl
}
